import React from 'react';
import Icon from '../../../components/AppIcon';

const IndustryCard = ({ industry, isSelected, onSelect }) => {
  return (
    <button
      onClick={() => onSelect(industry?.id)}
      className={`w-full p-6 rounded-xl border-2 transition-all duration-300 text-left ${
        isSelected
          ? 'border-primary bg-primary/5 shadow-elevated'
          : 'border-border bg-card hover:border-primary/50 hover:shadow-card'
      }`}
      aria-pressed={isSelected}
      aria-label={`Select ${industry?.name} industry`}
    >
      <div className="flex items-start gap-4">
        <div
          className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${
            isSelected ? 'bg-primary' : 'bg-muted'
          }`}
        >
          <Icon
            name={industry?.icon}
            size={24}
            color={isSelected ? '#FFFFFF' : 'var(--color-foreground)'}
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-foreground mb-1">
            {industry?.name}
          </h3>
          <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
            {industry?.description}
          </p>
          <div className="flex flex-wrap gap-2">
            {industry?.scenarios?.map((scenario, index) => (
              <span
                key={index}
                className="text-xs px-2 py-1 rounded-md bg-muted text-muted-foreground"
              >
                {scenario}
              </span>
            ))}
          </div>
        </div>
        {isSelected && (
          <div className="flex-shrink-0">
            <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center">
              <Icon name="Check" size={16} color="#FFFFFF" />
            </div>
          </div>
        )}
      </div>
    </button>
  );
};

export default IndustryCard;